import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import Logo from './logo';
import styles from './styles';

class Landing extends React.Component {
	render() {
		const {classes, history, t} = this.props;

		return (
			<Grid
				container
				alignItems="center"
				direction="column"
				className={classes.root}
			>
				<Logo classes={{root: classes.logo}}/>
				<Typography component="h3" variant="title" classes={{root: classes.title}}>
					{t('landing.title')}
				</Typography>
				<Typography component="p" variant="subheading" classes={{root: classes.text}}>
					{t('landing.text')}
				</Typography>
				<Button
					variant="contained"
					color="primary"
					className={classes.button}
					onClick={() => history.push('/easy-steps')}
				>
					{t('landing.button')}
				</Button>
			</Grid>
		);
	}
}

Landing.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	t: PropTypes.func.isRequired
};

export default withStyles(styles)(Landing);
